import { Component, OnInit, HostListener } from '@angular/core';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {
    public isScrolled = false;

    @HostListener('window:scroll', ['$event'])
    onScroll(event) {
        if (event) {
            const pos = window.pageYOffset;
            this.checkIfScrolled(pos);
        }
    }

    constructor() {}

    ngOnInit(): void {}

    public checkIfScrolled(position): void {
        if (position > 0) {
            this.isScrolled = true;
        } else {
            this.isScrolled = false;
        }
    }
}
